import React from 'react'
import { Button } from '@/Components/ui/button'
import { useNavigate } from 'react-router-dom'
import HeaderCard from '../HeaderCard'
import BodyCard from '../BodyCard'
import { Lock } from 'lucide-react'

const AccessDenied = () => {
    const navigate = useNavigate()

    const goBack = () => {
        navigate(-1)
    }

    return (
        <>
            <HeaderCard>
                <div className="flex justify-end items-center">
                    <div className="flex items-center justify-end gap-2">
                        <Button className="bg-transparent hover:bg-transparent text-black border border-gray-400" onClick={goBack}>
                            Back
                        </Button>
                    </div>
                </div>
            </HeaderCard>
            <BodyCard>
                <div className="max-h-full h-full flex-col flex justify-center items-center">
                    <div className="border border-gray-200 rounded-full p-8">
                        <Lock className="text-gray-400" />
                    </div>
                    <h1 className="text-3xl my-3 text-blue-500 font-bold ">ACCESS DENIED</h1>
                    <h4 className="text-gray-500 font-normal">You don't have permissions to access this page.</h4>
                    <h4 className="text-gray-500 font-normal">
                        Contact an administrator to get permissions or go to the previous page and browse other pages
                    </h4>
                    <Button className="hover:bg-transparent p-5 mt-5 bg-transparent text-blue-500 border-blue-500 border" onClick={goBack}>
                        Previous Page
                    </Button>
                </div>
            </BodyCard>
        </>
    )
}

export default AccessDenied
